import { Subject, of } from 'rxjs';
import { debounceTime, groupBy, mergeMap, switchMap } from 'rxjs/operators';

import { StorageSyncOptions } from './interfaces';

const sync$ = new Subject<Record<string, string>>();

sync$
  .pipe(
    groupBy((value) => value.key),
    mergeMap((action$) => {
      return action$.pipe(
        debounceTime(250),
        switchMap((project) => {
          sessionStorage.setItem(project.key, project.value);
          return of([]);
        })
      );
    })
  )
  .subscribe();

export const saveState = <T>(state: T, { prefix, features }: StorageSyncOptions<T>): void => {
  for (const feature of features) {
    const { stateKey } = feature;

    if (state[stateKey as keyof T] === undefined) {
      continue;
    }

    const key = `${prefix}-${stateKey}`;

    const value = JSON.stringify(state[stateKey as keyof T]);

    try {
      sync$.next({ key, value });
    } catch (e) {
      console.error('saveState error:', e);
    }
  }
};
